/*
  Braid Miracle native cart extras
  Replaces the Kaching Cart app:
    - free-shipping progress meter (rendered in Liquid, no JS needed)
    - <bm-cart-upsell>   related-products upsell with a variant chooser
    - <bm-variant-swap>  change the colour of a line already in the cart
*/
(function () {
  var CACHE = new Map();
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    function withCommas(n) {
      return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, key) {
      var value = cents / 100;
      switch (key) {
        case 'amount_no_decimals':
          return withCommas(String(Math.round(value)));
        case 'amount_with_comma_separator':
          return withCommas(value.toFixed(2)).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withCommas(String(Math.round(value))).replace(/,/g, '.');
        default:
          return withCommas(value.toFixed(2));
      }
    });
  }

  function sized(url, size) {
    if (!url) return '';
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + size + '$1$2');
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function optionName(product) {
    var opts = product.options;
    if (opts && opts.length) {
      var first = opts[0];
      if (typeof first === 'string' && first) return first;
      if (first && first.name) return first.name;
    }
    return 'option';
  }

  function repaint(parsed) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && parsed && parsed.sections && parsed.sections['cart-drawer']) {
      drawer.renderContents(parsed);
    } else {
      window.location.reload();
    }
  }

  /* ---------- Change the colour of a line already in the cart ---------- */
  class BMVariantSwap extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;

      var select = this.querySelector('.bm-swap__select');
      if (!select) return;

      var self = this;
      this._previous = select.value;
      select.addEventListener('change', function () {
        self.swap(select);
      });
    }

    async swap(select) {
      var newId = Number(select.value);
      var key = select.dataset.lineKey;
      var qty = Number(select.dataset.qty) || 1;
      if (!newId || !key) return;

      select.disabled = true;

      try {
        // Add the new colour first, so a failure here never empties their cart.
        var addRes = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: [{ id: newId, quantity: qty }] })
        });
        var added = await addRes.json();
        if (added.status) throw new Error(added.description || 'add failed');

        // Then drop the old line and re-render the drawer in one request.
        var changeRes = await fetch(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            id: key,
            quantity: 0,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        });
        repaint(await changeRes.json());
      } catch (e) {
        select.disabled = false;
        select.value = this._previous;
      }
    }
  }

  /* ---------- Related-products upsell ---------- */
  class BMCartUpsell extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      this.render();
    }

    async render() {
      var seed = this.dataset.productId;
      if (!seed) return;

      var inCart = (this.dataset.inCart || '').split(',').filter(Boolean);
      var products = CACHE.get(seed);

      if (!products) {
        try {
          var res = await fetch(
            ROOT + 'recommendations/products.json?product_id=' + seed + '&limit=8&intent=related'
          );
          if (!res.ok) return;
          var data = await res.json();
          products = data.products || [];
          CACHE.set(seed, products);
        } catch (e) {
          return;
        }
      }

      var picks = products
        .filter(function (p) {
          return p.available && inCart.indexOf(String(p.id)) === -1;
        })
        .slice(0, 2);

      if (!picks.length) return;

      var self = this;
      this.innerHTML =
        '<p class="bm-upsell__title">' +
        escapeHtml(this.dataset.title || 'Pairs well with your order') +
        '</p><ul class="bm-upsell__list">' +
        picks
          .map(function (p) {
            return self.card(p);
          })
          .join('') +
        '</ul>';

      this.querySelectorAll('.bm-upsell__item').forEach(function (li) {
        var select = li.querySelector('.bm-upsell__select');
        var btn = li.querySelector('.bm-upsell__add');
        if (!btn) return;

        if (select) {
          select.addEventListener('change', function () {
            btn.dataset.variantId = select.value;
            btn.disabled = !select.value;
          });
        }

        btn.addEventListener('click', function () {
          if (btn.dataset.variantId) self.add(btn);
        });
      });
    }

    card(product) {
      var fmt = this.dataset.moneyFormat;
      var variants = (product.variants || []).filter(function (v) {
        return v.available;
      });
      if (!variants.length) return '';

      var multi = variants.length > 1;
      var base = variants[0];
      var image = sized(product.featured_image, '120x');
      var onSale = base.compare_at_price && base.compare_at_price > base.price;
      var label = optionName(product);

      var chooser = '';
      if (multi) {
        chooser =
          '<select class="bm-upsell__select" aria-label="Choose ' +
          escapeHtml(label) +
          ' for ' +
          escapeHtml(product.title) +
          '">' +
          '<option value="">Choose ' +
          escapeHtml(label.toLowerCase()) +
          '</option>' +
          variants
            .map(function (v) {
              return '<option value="' + v.id + '">' + escapeHtml(v.title) + '</option>';
            })
            .join('') +
          '</select>';
      }

      return (
        '<li class="bm-upsell__item">' +
        '<a class="bm-upsell__media" href="' +
        escapeHtml(product.url) +
        '" tabindex="-1" aria-hidden="true">' +
        (image
          ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="60" height="60">'
          : '') +
        '</a>' +
        '<div class="bm-upsell__info">' +
        '<a class="bm-upsell__name" href="' +
        escapeHtml(product.url) +
        '">' +
        escapeHtml(product.title) +
        '</a>' +
        '<span class="bm-upsell__price">' +
        (onSale
          ? '<s class="bm-upsell__was">' + formatMoney(base.compare_at_price, fmt) + '</s> '
          : '') +
        formatMoney(base.price, fmt) +
        '</span>' +
        chooser +
        '</div>' +
        '<button type="button" class="bm-upsell__add"' +
        (multi ? ' disabled data-variant-id=""' : ' data-variant-id="' + base.id + '"') +
        ' aria-label="Add ' +
        escapeHtml(product.title) +
        ' to cart">Add</button>' +
        '</li>'
      );
    }

    async add(btn) {
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding';

      try {
        var res = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        });

        var parsed = await res.json();
        if (parsed.status) throw new Error(parsed.description || 'add failed');
        repaint(parsed);
      } catch (e) {
        btn.disabled = false;
        btn.textContent = label;
      }
    }
  }

  if (!customElements.get('bm-variant-swap')) {
    customElements.define('bm-variant-swap', BMVariantSwap);
  }
  if (!customElements.get('bm-cart-upsell')) {
    customElements.define('bm-cart-upsell', BMCartUpsell);
  }
})();